var React = require('react');

function IgniterBug (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"igniter-media-bug"),React.createElement("path",{"className":"primary-fill","d":"M35.35,0A35.35,35.35,0,1,0,70.7,35.35,35.35,35.35,0,0,0,35.35,0m4,60.31c-7.5.63-12.19-6.1-12.77-7.22-.44-.79-.65-.12-.4.63,1.4,4.18,3.44,6.14,7.74,9.06C23.06,61.26,18,51.44,18.53,44.85c.66-7.55,5.09-8.4,8.49-20.67,2.27,4.16,1.42,6,1.56,8.87,0,.26.07.42.23.24,3.33-3.41,2.67-9.87,4.08-14.75s3-7,4.85-10a4.63,4.63,0,0,1,.59-.6,4.41,4.41,0,0,1,.12.59c.17,2.28.15,12,4.23,20,4.49,8.14,9.54,11.33,9.54,18.2,0,7.48-5,12.93-12.82,13.59","key":1})]);
}

IgniterBug.defaultProps = {"className":"logo bug producer igniter-media","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 70.7 70.7"};

module.exports = IgniterBug;

IgniterBug.default = IgniterBug;
